import { render, staticRenderFns } from "./CallTableGiftsReportActions.vue?vue&type=template&id=40a89a91&scoped=true"
import script from "./CallTableGiftsReportActions.vue?vue&type=script&lang=js"
export * from "./CallTableGiftsReportActions.vue?vue&type=script&lang=js"
import style0 from "./CallTableGiftsReportActions.vue?vue&type=style&index=0&id=40a89a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a89a91",
  null
  
)

export default component.exports